import { Console } from 'console';
import { PlantService } from 'src/app/services/plant.service';
import { DatePipe } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbDate, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { ExcelDataProvider } from 'src/app/_Core/_Providers/excel.provider';
// import { DateService } from 'src/app/_Core/_Services/date.service';
// import { AppStateProvider } from 'src/app/_Core/_Providers/app-state.provider';
import { AppStateProvider } from 'src/app/services/app-state.provider';


@Component({
  standalone: false,
  selector: 'app-bulk-upload-preview',
  templateUrl: './bulk-upload-preview.component.html',
  styleUrls: ['./bulk-upload-preview.component.scss']
})
export class BulkUploadPreviewComponent implements OnInit, OnDestroy {
  name: boolean;
  fieldErrors: any[];
  mobile: any;
  email: any;
  guestName: any;
  guestMobile: boolean;
  guestEmail: any;
  vehicleNumber: any;
  vehicleType: any;
  floor: any;
  buildingName: any;
  formatDate: string;
  buildingTitle: string = '';
  amorpm: boolean = false;
  amorpm1: boolean = false;
  normalizeTime: any;
  remarks: string = '';
  startTimePlaceholder: string = '';
  endTimePlaceholder: string = '';
  buildingProperty: any = [];
  floorProperty: any = [];
  floorTitle: any;
  tableHeaders: any[] = [];
  tableBody: any = [];
  selectAll: boolean = false;
  popover: any = null;
  meridian: boolean = true;
  startTime = { hour: 7, minute: 0 };

  data: any;
  fullname: string;
  mobileNumber: any;
  emailId: string;
  myCompanyData: any;
  buildingId: any;
  guestList: any;
  floorCount: any;
  floorList: any;
  vehicleTypeList: any;
  meetingPurposeData: any;
  tempMeetingPurposeData: any;
  meetingPurpose: any;
  t0600Vmsguests: any = [];
  allVegitationData: any = [];
  vegetationNotes: any = [];
  mdate: any;
  selectedDate: any;
  userId: any;
  mend: any;
  tempTime: any;
  tempEndTime: any;
  id: any;
  tempGuestList: any = [];
  showError: boolean;
  errName: any;
  errfloor: any;
  sDate: any;
  minDate = undefined;
  fDate: any;
  time1: any;
  time2: any;
  validationError: any[];
  isValid: any[];
  isValidtRow: any[];
  totalInValidRows: number;
  totalValidRows: number;
  data2: any;
  isOperationCompleted: boolean;
  tempHeaders: any[];
  validationEr: boolean;
  errDate: any;
  basementCount: any;
  constructor(
    private router: Router,
    // private dateSrv: DateService,
    public datepipe: DatePipe,
    private ngbDatepickerConfig: NgbDatepickerConfig,
    private excelProvider: ExcelDataProvider,
    private activatedRoute: ActivatedRoute,
    private plantService: PlantService,
    private appStateSrv: AppStateProvider
  ) {
    const current = new Date();
    ngbDatepickerConfig.minDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate(),
    };

    ngbDatepickerConfig.outsideDays = 'hidden';
  }

  ngOnInit(): void {

    localStorage.setItem('expandNavLand', 'true');

    // this.onTimeChange(this.startTime)
    this.activatedRoute.queryParams.subscribe(res => {
      this.id = res.id ? res.id : null
    })
    // this.getBuildingList();
    // this.getVehicleType();
    // this.getMeetingPurpose();

    // if (this.id !== null) this.loadData(this.id);
    // else this.getMyCompanyDetails(localStorage.getItem('userId'));

    this.data = this.plantService.getExcelData();
    if (this.data != null) {
      // this.processApiResponse(JSON.parse(this.data).map(obj => ({ ...obj, validationIssues: true, isValid: true, isValidRow: true })));
      this.processApiResponse(JSON.parse(this.data).map(obj => ({ ...obj })));
    }

    const jsDate = new Date();
    // const route = {
    //   index: '3',
    //   name: 'VMS',
    //   link: '',
    //   sub:[
    //     {
    //       index: '1',
    //       name: 'Bulk Invite',
    //       image: '',
    //       selectedImage: '',
    //       link: '/vms/bulk-invite/preview?id='+this.id,
    //     }]
    // };
    // localStorage.setItem('expandNav','true');
    // this.appStateSrv.setSideNavState(route);
  }

  ngOnDestroy() {
    localStorage.removeItem('expandNavLand');

    // this.subscriptions.unsubscribe();
  }

  // loadData(id) {
  //   const data = {
  //     InvitationID: id,
  //   };

  //   this.plantService.getInvitationDetail(data).subscribe((res) => {
  //     console.log(res)
  //     for (let i = 0; i < res?.t0600Vmsguests.length; i++) {
  //       const tempGuestList = {
  //         "Sr.No.": i + 1,
  //         "Guest name": res?.t0600Vmsguests[i].fullName,
  //         "Email ID": res?.t0600Vmsguests[i].email,
  //         "Contact No.": res?.t0600Vmsguests[i].mobile,
  //       }
  //       this.tempGuestList.push(tempGuestList)
  //     }
  //     this.processApiResponse(this.tempGuestList.map(obj => ({ ...obj, validationIssues: true, isValid: true, isValidRow: true })))
  //     // this.getMyCompanyDetails(res?.parkUserId)
  //     this.setBuildingName(res?.buildingId, res?.buildingName, res?.floor);
  //     this.setFloor(res?.floor)

  //   });
  // }

  // public updateSelectedDate(date: NgbDate) {
  //   const jsDate = new Date(date.year, date.month - 1, date.day);
  //   // this.selectedDate = this.datepipe.transform(jsDate, 'yyyy-MM-dd');
  //   this.selectedDate = this.convertFormat(date.year, date.month, date.day);
  //   this.formatDate = this.dateSrv.convertDateToLocaleString(
  //     date.day,
  //     date.month - 1,
  //     date.year
  //   );
  //   this.formatDate = this.formatDate.split(' ')[0] + ' ' + this.formatDate.split(' ')[1] + ' ' + this.formatDate.split(' ')[2];
  // }

  convertFormat(y, m, d) {
    return y + '-' + m + '-' + d;
  }

  onClickedOutside(e: Event) {
    // console.log('Clicked outside:', e);
  }

  openPopover(popover) {
    this.popover = popover
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }



  enterName(field) {
    if (field == 'name') {
      this.name = !this.name;

    }
    if (field == 'mobile') {
      this.mobile = !this.mobile;

    }
    if (field == 'email') {
      this.email = !this.email;
    }
    if (field == 'guestName') {
      this.guestName = !this.guestName;
    }
    if (field == 'guestMobile') {
      this.guestMobile = !this.guestMobile;
    }
    if (field == 'guestEmail') {
      this.guestEmail = !this.guestEmail;
    }
    if (field == 'vehicleNumber') {
      this.vehicleNumber = !this.vehicleNumber;
    }
    if (field == 'vehicleType') {
      this.vehicleType = !this.vehicleType;
    }
    if (field == 'floor') {
      this.floor = !this.floor;
    }
    if (field == 'buildingName') {
      this.buildingName = !this.buildingName;
    }
    if (field == 'startDate') {
      this.sDate = !this.sDate;
    }
    if (field == 'time') {
      this.time1 = !this.time1;
    }
    if (field == 'time2') {
      this.time2 = !this.time2;
    }
  }

  bulkInvite(data) {
    var files = data.target.files; // FileList object
    var xl2json = new this.excelProvider.ExcelToJSON();
    xl2json.parseExcel(files[0]).then(data => {
      // this.processApiResponse(JSON.parse(data).map(obj => ({ ...obj, validationIssues: true, isValid: true, isValidRow: true })));
      this.processApiResponse(JSON.parse(data).map(obj => ({ ...obj })));
    }).catch(err => {
    });
  }

  prepareTableData(tableData) {

    this.tableBody = [];
    this.tableHeaders = [];
    // this.tableBody = tableData
    let sampleheaders = [];

    for (let header of tableData)
      sampleheaders.push(...Object.keys(header));

    this.tableHeaders = [...new Set(sampleheaders)];

    for (let body of tableData) {
      let temp = [];
      for (let head of this.tableHeaders) {
        temp.push(body[head] == undefined ? '' : body[head])
      }
      this.tableBody.push(temp);
      console.log(this.tableBody);
      this.guestList = this.tableBody

    }
  }

  selectAllHandler() {
    if (this.selectAll) { }
  }

  selectedGuest(guestData, index) {

  }
  deleteAllInvites() {
    if (this.selectAll) {
      this.tableBody = [];
      this.tableHeaders = [];
    }
  }

  generateUniqueId(i, type) {
    return i + '__' + type;
  }

  checkIfSelected(id: string) {
    const ele = document.getElementById(id) as HTMLInputElement;
    return !ele.checked ? 'disabledClick' : ''
  }

  deleteSelected(inviteData, i) {
    console.log(inviteData)
    if (this.checkIfSelected(i + '__th') !== 'disabledClick')
      this.tableBody.splice(i, 1)

    this.processApiResponse(this.reprepareData(this.tableBody, this.tableHeaders))
    // this.bulkInviteValidation(this.tableBody)
  }

  reprepareData(tb, th) {

    // console.log("tb",tb)
    // console.log('th',th)


    var finalB = []
    tb.forEach(res => {
      let bdata = {};
      res.forEach((tb, bodyIndex) => {
        //console.log(body);
        th.forEach((head, headIndex) => {
          // console.log(head)
          if (bodyIndex == headIndex) {
            bdata[head] = tb
          }
        })

      })
      // console.log(bdata);
      finalB.push(bdata)

    })

    return finalB
  }

  // toggleAmPmSelection(value: boolean) {
  //   this.amorpm = value;
  //   this.onTimeChange(this.tempTime);
  // }

  toggleMeridian() {
    this.meridian = !this.meridian;
  }


  // onTimeChange(e) {
  //   this.tempTime = e;

  //   console.log(e, this.amorpm);
  //   if (e.hour >= 0 && e.hour <= 11) this.amorpm = false;
  //   else this.amorpm = true;
  //   this.startTimePlaceholder =
  //     ('0' + (e.hour > 12 ? e.hour - 12 : e.hour)).slice(-2) +
  //     ':' +
  //     ('0' + e.minute).slice(-2) +
  //     ' ' +
  //     (this.amorpm ? 'PM' : 'AM');
  //   console.log('time', this.startTimePlaceholder);
  // }

  // onTimeChange(e) {
  //   this.tempTime=e;

  //   // if (e.hour >= 0 && e.hour <= 11) this.amorpm = false;
  //   // else this.amorpm = true;
  //   this.startTimePlaceholder =
  //     ('0' + (e.hour > 12 ? e.hour - 12 : e.hour)).slice(-2) +
  //     ':' +
  //     ('0' + e.minute).slice(-2) +
  //     ' ' +
  //     (this.amorpm ? 'PM' : 'AM');

  // }



  editSelected(from, to, i, type) {

    if (this.checkIfSelected(i + '__th') !== 'disabledClick') {
      if (document.getElementById(i + '__edit').style.display == 'block') {
        document.getElementById(i + '__edit').style.display = 'none';
        document.getElementById(i + '__save').style.display = 'block'
      } else {
        document.getElementById(i + '__edit').style.display = 'block';
        document.getElementById(i + '__save').style.display = 'none'
      }

      let fromEle = document.getElementsByClassName(from);
      let toEle = document.getElementsByClassName(to);

      for (let el of Object.keys(fromEle))
        if (document.getElementsByClassName(from)[el].style.display == 'block')
          document.getElementsByClassName(from)[el].style.display = 'none';
        else
          document.getElementsByClassName(from)[el].style.display = 'block';

      for (let el of Object.keys(toEle))
        if (document.getElementsByClassName(to)[el].style.display == 'block')
          document.getElementsByClassName(to)[el].style.display = 'none';
        else
          document.getElementsByClassName(to)[el].style.display = 'block';

      if (type == 'save') {
        let _t = [];
        for (let el of Object.keys(toEle)) {
          _t.push(document.getElementsByClassName(to)[el].value);

        }
        _t.push(true, true, true);
        this.tableBody.splice(i, 1, _t);
        this.processApiResponse(this.reprepareData(this.tableBody, this.tableHeaders))
      }

    }
  }

  // getMyCompanyDetails(id) {
  //   const ParkId = localStorage.getItem('tenantId')

  //   this.plantService
  //     .getParkiteHostList(ParkId)
  //     .subscribe((response: any) => {


  //       this.myCompanyData = response?.list;
  //       this.data = this.myCompanyData.filter((el) => el.userId == id);

  //       if (this.data.length == 0) {
  //         return this.router.navigate(['/vms/bulk-invite'])
  //       }

  //       this.fullname = this.data[0].userName;
  //       this.getHostDetail(this.data[0].userId);

  //     });
  // }

  // setFullName(item) {
  //   this.fullname = item.userName;
  //   this.getHostDetail(item.userId);
  // }

  // setBuildingName(itemId, itemName,item) {
  //   this.floorTitle='0'
  //   this.floorList=[]
  //   console.log("item",item)
  //   this.buildingTitle = itemName;
  //   this.buildingId = itemId;
  //   this.floorCount =  item.floors;
  //   if ( this.floorCount == null) {
  //     this.floorList.push('0');
  //   }
  //   for (let i = 0; i <= this.floorCount; i++) {
  //     this.floorList.push(i);
  //   }


  // }

  // setBuildingName(itemId, itemName, item) {
  //   console.log("inside set building")
  //   this.floorTitle = '0'
  //   this.floorList = []
  //   let basement = []
  //   let flr = [];
  //   console.log("item", item)
  //   console.log(item.floors)
  //   this.buildingTitle = itemName;
  //   this.buildingId = itemId;
  //   this.floorCount = item.floors;
  //   this.basementCount = item?.basements;
  //   if (this.floorCount == 0 || this.floorCount == null) {
  //     this.floorList.push('0');
  //   }
  //   for (let i = 0; i <= this.floorCount; i++) {
  //     flr.push(i);
  //   }
  //   for (let i = this.basementCount; i > 0; i--) {
  //     basement.push(i * (-1))
  //   }
  //   this.floorList = basement.concat(flr)
  // }


  // setFloor(item) {
  //   this.floorTitle = item;
  // }

  // setVehicleType(item, i) {
  //   this.guestList[i].vehicleType = item.vehicleType;
  // }

  /* getHostDetail(data) {
    this.floorList = [];
    this.userId = data;

    const param = {
      userId: data,
    };
    this.plantService.getHostDetail(param).subscribe((res) => {

      this.mobileNumber = res.data ? res.data.mobile : res.mobile;
      this.emailId = res.data ? res.data.emailId : res.emailId;
      // this.buildingProperty = res.data?res.data.userBuilding:res.userBuilding;
      //   this.floorCount = res.data?res.data.floors:res.floors;
      //   if(this.floorCount==0||this.floorCount==null){
      //     this.floorList.push('1');
      //   }
      //   for (let i = 1; i < this.floorCount; i++) {
      //     this.floorList.push(i);
      //   }
    });
  } */

  // getBuildingList() {
  //   const data = {
  //     parkid: localStorage.getItem('parkId')
  //   }
  //   this.plantService.getBuildingList(data).subscribe(res => {
  //     this.buildingProperty = res?.list
  //   })
  // }

  // getVehicleType() {
  //   this.plantService.getVehicleType().subscribe((res) => {

  //     this.vehicleTypeList = res;
  //   });
  // }

  // getMeetingPurpose() {
  //   this.plantService.getMeetingPurpose().subscribe((res) => {
  //     this.meetingPurposeData = res;

  //     this.tempMeetingPurposeData = this.meetingPurposeData.filter(
  //       (el) => el.meetingPurpose.trim() == 'Official'
  //     );

  //     this.meetingPurpose = this.tempMeetingPurposeData[0].meetingPurposeId;
  //   });
  // }

  // concatDateTime(type) {
  //   if (type == 'mstart') {
  //     return this.selectedDate.concat(
  //       ' ' + this.startTimePlaceholder
  //     );
  //   }
  //   else {
  //     return this.selectedDate.concat(
  //       ' ' + '07:00 PM'
  //     );
  //   }
  // }

  send() {

    // this.validation(val);
    // if (this.showError == true) {
    //   return;
    // }

    // if (this.validationEr == true) {
    //   return
    // }


    this.allVegitationData = [];
    this.vegetationNotes = [];

    // if (this.amorpm == true) {
    //   if (parseInt(this.startTimePlaceholder.split(':')[0]) > 7 && parseInt(this.startTimePlaceholder.split(':')[0]) !== 12) {
    //     this.appStateSrv.showToast(' Visitors are allowed in the park only between 7 am - 7 pm.');
    //     return;
    //   }
    // }
    // else {
    //   if (parseInt(this.startTimePlaceholder.split(':')[0]) < 7 && parseInt(this.startTimePlaceholder.split(':')[0]) > 11) {
    //     this.appStateSrv.showToast(' Visitors are allowed in the park only between 7 am - 7 pm.');
    //     return;
    //   }
    // }

    // this.mdate = this.concatDateTime('mstart');
    // this.mend = this.concatDateTime('mend');

    console.log(this.guestList);

    for (let i = 0; i < this.guestList.length; i++) {

      const guestData =
      {
        VegetationName: this.guestList[i][0],
        Species: this.guestList[i][1],
        parkName: this.guestList[i][2],
        vegetationNotes: [{
          headline: this.guestList[i][3],
          description: this.guestList[i][4],
        },
        {
          headline: this.guestList[i][5],
          description: this.guestList[i][6],
        },
        {
          headline: this.guestList[i][7],
          description: this.guestList[i][8],
        }],
      }
      this.allVegitationData.push(guestData);
    }

    const data = {
      CreatedBy: localStorage.getItem('claAdminId'),
      IsActive: true,
      vegetationBulkUpload: this.allVegitationData,
    };

    console.log(data);

    // may we use it later
    this.plantService.createInvitation(data).subscribe((res) => {
      if (res?.isValid == true) {
        this.router.navigate(['/listplants/']);
      }
    });
  }


  validation(validate) {
    this.showError = false;
    this.errName = validate.form.controls.building?.status;
    this.errDate = validate.form.controls.fdate?.status
    if (this.errName == 'INVALID' || this.errDate == 'INVALID')
      this.showError = true;

  }

  processApiResponse(data) {

    if (data.length > 200) {
      this.appStateSrv.showToast('Vegitation list cannot exceed 200');
      return;
    }

    console.log("processAPI res", data)

    this.bulkInviteValidation(data);

    if (data != null) {

      this.validationError = [];
      this.isValid = [];
      this.isValidtRow = [];
      data.map(result => {
        this.validationError.push(result.validationIssues)
        this.isValid.push(result.isValid)
        this.isValidtRow.push(result.isValidRow)
      });
      this.prepareTableData(data)
      this.totalInValidRows = 0;
      this.totalValidRows = 0;
      for (let rowEmp of this.isValidtRow) {
        if (rowEmp == false)
          this.totalInValidRows++;
        else
          this.totalValidRows++;
      }
    }
  }

  bulkInviteValidation(data) {
    console.log(data)
    console.log(JSON.parse(JSON.stringify(data).replace(/\s/g, "").replace(/\./g, "")))

    this.validationEr = false;

    JSON.parse(JSON.stringify(data).replace(/\s/g, "")).forEach((res, i) => {
    });

    JSON.parse(JSON.stringify(data).replace(/\s/g, "").replace(/\./g, "")).forEach((res, i) => {

      console.log(res);

      if (res.PlantSpecies == undefined || res.PlantSpecies.length == 0) {
        data[i].isValid = false
        data[i].isValidRow = false;
        data[i].validationIssues = false;
        this.validationEr = true;
      }
      if (res.PlantName == undefined || res.PlantName.length == 0) {
        data[i].isValid = false
        data[i].isValidRow = false;
        data[i].validationIssues = false;
        this.validationEr = true;
      }
      if (res.ParkName == undefined || res.ParkName.length == 0) {
        data[i].isValid = false
        data[i].isValidRow = false;
        data[i].validationIssues = false;
        this.validationEr = true;
      }
      if (res.NoteHeading1 == undefined || res.NoteHeading1.length == 0) {
        data[i].isValid = false
        data[i].isValidRow = false;
        data[i].validationIssues = false;
        this.validationEr = true;
      }
      if (res.NoteHeading2 == undefined || res.NoteHeading2.length == 0) {
        data[i].isValid = false
        data[i].isValidRow = false;
        data[i].validationIssues = false;
        this.validationEr = true;
      }
      if (res.NoteHeading3 == undefined || res.NoteHeading3.length == 0) {
        data[i].isValid = false
        data[i].isValidRow = false;
        data[i].validationIssues = false;
        this.validationEr = true;
      }
      if (res.NoteDescription1 == undefined || res.NoteDescription1.length == 0) {
        data[i].isValid = false
        data[i].isValidRow = false;
        data[i].validationIssues = false;
        this.validationEr = true;
      }
      if (res.NoteDescription2 == undefined || res.NoteDescription2.length == 0) {
        data[i].isValid = false
        data[i].isValidRow = false;
        data[i].validationIssues = false;
        this.validationEr = true;
      }
      if (res.NoteDescription3 == undefined || res.NoteDescription3.length == 0) {
        data[i].isValid = false
        data[i].isValidRow = false;
        data[i].validationIssues = false;
        this.validationEr = true;
      }
      // if (res.SrNo == undefined || res.SrNo.length == 0 || !/^[0-9]+$/.test(res.SrNo)) {
      //   data[i].isValid = false
      //   data[i].isValidRow = false;
      //   data[i].validationIssues = false;
      //   this.validationEr = true;
      // }
    });
  }

  updateTable(data) {
    this.processApiResponse(this.reprepareData(this.tableBody, this.tableHeaders))
  }

}

